// extracted by mini-css-extract-plugin
export default {"btop":"d824d36036 _32fd2d5bc2 _70e0c8d879","icon":"_5556f8a12f _463239a570","btoppink":"_3f3e9a3e6e ee83a5f1bb"};